import { useEffect, useState } from 'react';
import './style/Tests.css';
import TestCard from '../components/TestCard.js';
import { authFetch } from '../authFetch';

function Tests(props) {
    const [tests, setTests] = useState([]);
    const [showModule1, setShowModule1] = useState(false);
    const [showEasy, setShowEasy] = useState(false);
    const [showHard, setShowHard] = useState(false);
    const [showCompleted, setShowCompleted] = useState(false);
    const [showInProgress, setShowInProgress] = useState(false);
    const [showNotStarted, setShowNotStarted] = useState(false);
    const [cardsLoaded, setCardsLoaded] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const maxTests = 10;

    const generateTest = async (module, difficulty = null) => {
        if (generating) return;
        setGenerating(true);
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_BASE}/tests/generateTest`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module, difficulty }),
            });
            const data = await response.json();
            if (data.success) {setTests(prevTests => [...prevTests, data.test]);} 
            else {console.log('Failed to generate test');}
        } 
        catch (error) {
            console.error('Error generating test:', error);
        }
        finally {
            setGenerating(false);
        }
    }

    const searchTest = async () => {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_BASE}/tests/searchTest/${searchInput}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (data.success) {
                if (!tests.some(test => test.test_id === data.test.test_id)) {setTests(prevTests => [...prevTests, data.test]);} 
                else {console.log('Test already in list');}
            }
            else {console.log('Test not found');}
        } 
        catch (error) {
            console.error('Error searching for test:', error);
        }
    }

    useEffect(() => {
        const loadTests = async () => {
            try {
                const response = await authFetch(`${process.env.REACT_APP_API_BASE}/tests/loadTests`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
                const data = await response.json();
                if (data.success) {setTests(data.tests);} 
                else {console.log('No tests found');}
            } 
            catch (error) {
                console.error('Error loading tests:', error);
            }
            finally {setCardsLoaded(true);}
        };
        loadTests();
    }, []);

    return (    
        <div className="tests-container">
            <div className="filter-sidebar">
                <form>
                    <section>
                        <div className="section-title">
                            <p>Status</p>
                        </div>
                        <div className="filter-options">
                            <label>
                                <input type="checkbox" name="completed" checked={showCompleted} onChange={() => setShowCompleted(!showCompleted)} />
                                Completed
                            </label>
                            <label>
                                <input type="checkbox" name="in_progress" checked={showInProgress} onChange={() => setShowInProgress(!showInProgress)} />
                                In Progress
                            </label>
                            <label>
                                <input type="checkbox" name="not_started" checked={showNotStarted} onChange={() => setShowNotStarted(!showNotStarted)} />
                                Not Started
                            </label>
                        </div>
                    </section>
                    <section>
                        <div className="section-title">
                            <p>Module</p>
                        </div>
                        <div className="filter-options">
                            <label>
                                <input type="checkbox" name="module1" checked={showModule1} onChange={() => setShowModule1(!showModule1)} />
                                Module 1
                            </label>
                            <label>
                                <input type="checkbox" name="easy" checked={showEasy} onChange={() => setShowEasy(!showEasy)} />
                                Module 2 (Easy)
                            </label>
                            <label>
                                <input type="checkbox" name="hard" checked={showHard} onChange={() => setShowHard(!showHard)} />
                                Module 2 (Hard)
                            </label>
                        </div>
                    </section>
                    <section>
                        <div className="section-title">
                            <p>Generate</p>
                        </div>
                        <div className="generate-options">
                            {tests.length < maxTests ? (generating ? (
                                <div className='generate-spinner' />
                            ) : (
                                <>
                                    <button type="button" onClick={() => {generateTest(1, null)}}>Module 1</button>
                                    <button type="button" onClick={() => {generateTest(2, 'Easy')}}>Module 2 (Easy)</button>
                                    <button type="button" onClick={() => {generateTest(2, 'Hard')}}>Module 2 (Hard)</button>
                                </>
                            )) : (
                                <p className="max-tests-message">Max of {maxTests} tests reached. Delete a test to generate more.</p>
                            )}
                        </div>
                    </section>
                    <section>
                        <div className="section-title">
                            <p>Search</p>
                        </div>
                        <div className="search-options">
                            <input type="text" placeholder="Enter test UUID..." value={searchInput} onChange={(e) => {setSearchInput(e.target.value)}} />
                            <button type="button" onClick={() => {searchTest()}}>Add Test</button>
                        </div>
                    </section>
                </form>
            </div>
            <div className="grid">
                {!cardsLoaded ? (
                    Array.from({ length: 6 }).map((_, i) => (
                        <div key={i} className="skeleton-test-card"><div className="shimmer"></div></div>
                    ))
                ) : (
                    (() => {
                      const filtered = tests
                        .filter(test => {
                          if (!showCompleted && !showInProgress && !showNotStarted) return true;
                          if (showCompleted && test.status === 'completed') return true;
                          if (showInProgress && test.status === 'in_progress') return true;
                          if (showNotStarted && test.status === 'not_started') return true;
                          return false;
                        })
                        .filter(test => {
                          if (!showModule1 && !showEasy && !showHard) return true;
                          if (showModule1 && test.module === 1) return true;
                          if (showEasy && test.module === 2 && test.difficulty === 'Easy') return true;
                          if (showHard && test.module === 2 && test.difficulty === 'Hard') return true;
                          return false;
                        });
                      return (
                        <>
                          {filtered.length > 0 ? (
                            filtered.map((test) => (
                              <TestCard key={test.test_id} test={test} user={props.user} onDelete={(testId) => setTests(prev => prev.filter(t => t.test_id !== testId))} />
                            ))
                          ) : !generating ? (
                            <div className="empty-state">
                              <p>No tests found</p>
                              <p>Generate a test to get started</p>
                            </div>
                          ) : null}
                          {generating && <div className="skeleton-test-card"><div className="shimmer"></div></div>}
                        </>
                      );
                    })()
                )}
            </div>
        </div>
    );
}

export default Tests;